<template>
  <div v-if="!item.hidden && item.children" class="menu-wrapper">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <el-menu-item
        :index="resolvePath(onlyOneChild.path)"
        :class="{ 'submenu-title-noDropdown': !isNest }"
        @click="turnToPage(onlyOneChild)"
        :disabled="checkPermission(item)"
        v-permission="onlyOneChild.permission"
      >
        <item
          v-if="onlyOneChild.meta"
          :iconfont="resolveMetaIconfont(onlyOneChild.meta, item.meta)"
          :icon="resolveMetaIcon(onlyOneChild.meta, item.meta)"
          :title="generateTitle(onlyOneChild.meta.title)"
          v-permission="onlyOneChild.permission"
        />
      </el-menu-item>
    </template>

    <el-submenu
      v-else
      ref="submenu"
      :index="resolvePath(item.path)"
      :disabled="checkPermission(item)"
      v-permission="item.permission"
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="resolveMetaIcon(item.meta)"
          :iconfont="resolveMetaIconfont(item.meta)"
          :title="generateTitle(item.meta.title)"
        />
      </template>

      <template v-for="child in item.children">
        <template v-if="!child.hidden">
          <sidebar-item
            v-if="child.children && child.children.length > 0"
            :is-nest="true"
            :item="child"
            :key="child.path"
            v-permission="child.permission"
            :base-path="resolvePath(child.path)"
            class="nest-menu"
          />

          <el-menu-item
            :index="resolvePath(child.path)"
            :key="resolvePath(child.path)"
            @click="turnToPage(child)"
            v-permission="child.permission"
            :disabled="checkPermission(child)"
          >
            <item
              v-if="child.meta"
              :icon="resolveMetaIcon(child.meta)"
              :title="generateTitle(child.meta.title)"
              :iconfont="resolveMetaIconfont(child.meta)"
              v-permission="child.permission"
            />
          </el-menu-item>
        </template>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import Item from "./Item";
import { generateTitle } from "@/utils/i18n";
import { getProviderType } from "@/utils/user";

export default {
  name: "SidebarItem",
  components: { Item },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      onlyOneChild: null,
    };
  },
  methods: {
    hasOneShowingChild(children, parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        } else {
          this.onlyOneChild = item;
          return true;
        }
      });

      if (showingChildren.length === 1) {
        return true;
      }

      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      return path.resolve(this.basePath, routePath);
    },
    turnToPage(params) {
      this.$router.push({ path: params.path });
    },
    resolveMetaIcon(meta, parentMeta = {}) {
      if (meta.hasOwnProperty("icon")) {
        return meta.icon;
      }
      if (parentMeta.hasOwnProperty("icon")) {
        return parentMeta.icon;
      }
      return "";
    },
    resolveMetaIconfont(meta, parentMeta = {}) {
      if (meta.hasOwnProperty("iconfont")) {
        return meta.iconfont;
      }
      if (parentMeta.hasOwnProperty("iconfont")) {
        return parentMeta.iconfont;
      }
      return "";
    },
    generateTitle,
    checkPermission(route) {
      const providerType = getProviderType();
      const { meta } = route;
      if (meta && meta.hasOwnProperty("disabledRoles")) {
        const disabledRoles = meta.disabledRoles;
        return disabledRoles.includes(providerType);
      }
      return false;
    },
  },
};
</script>
